import React, { Component } from 'react';
import ReactHtmlParser from "react-html-parser";

/**
 * This CTA (Call-to-Action) box can be placed in any container or banner and positioned accordingly. 
 * Styles for this component should be cascaded and modified with an additional stylesheet.
 * 
*/

class StandardCtaBox extends Component {
    render() {
        return (
            <div id="stdCtaBox" className="std-ctabox__block ubuntu--bold">
                <h3 className="std-ctabox__title" tabIndex="0">{ReactHtmlParser(this.props.ctaTitle)}</h3>
                <p className="std-ctabox__text ubuntu--bold" tabIndex="0">{ReactHtmlParser(this.props.ctaContentText)}</p>
                <a className="std-ctabox__cta btn btn-sunrise"
                    href={this.props.ctaButtonHref}
                    aria-label={ReactHtmlParser(this.props.ariaLabel)}>
                    {ReactHtmlParser(this.props.ctaButtonLabel)}
                </a>
            </div>
        );
    }
}

export default StandardCtaBox;